/*
 * @Author: kongxiangyu
 * @Date: 2022-11-19 14:06:00
 * @LastEditTime: 2023-02-09 14:54:24
 * @email: kongxiangyu@cd.baidu.com
 * @Description: 双旦预售
 */
import Vue from 'vue';
import Router from 'vue-router';
import '@/common/style/index.scss';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/main/Main.vue'),
            meta: {
                title: '美食周末预售'
            }
        }
    ]
});
